import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "~/lib/utils";

type ToolTip = Omit<React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>, "title"> & { title?: React.ReactNode };

const Tooltip = React.forwardRef<React.ElementRef<typeof TooltipPrimitive.Content>, ToolTip>(({ children, title, className, sideOffset = 4, ...props }, ref) => {
  // Function to split the title by comma and add a break for a new line
  const formatTitle = (title: string) =>
    typeof title === "string" && title?.includes(",")
      ? title?.split(",")?.map((line, index) => (
          <React.Fragment key={index?.toString()}>
            {line?.trim()}
            {index < title?.split(",")?.length - 1 && <br />}
          </React.Fragment>
        ))
      : title;

  return (
    <TooltipPrimitive.Provider>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          <span className="relative">{children}</span>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Content
          ref={ref}
          sideOffset={sideOffset}
          className={cn(
            "z-50 overflow-hidden max-h-72 overflow-y-auto shadow rounded-md bg-background px-3 py-1.5 text-xs text-accent-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            className,
          )}
          {...props}
        >
          {title && typeof title === "string" ? formatTitle(title) : title}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
});

Tooltip.displayName = "Tooltip";

export { Tooltip };
